// Values mirror the `data-subscription-entry` attribute read by the GTM container, and are
// reused as the `subscription_entry` cookie value and the `entry_point` event param.
const SubscriptionEntryPoints = {
  LISTING_FREE_FILTER_UPSELL: 'listing_free_filter_upsell',
  ITEM_PAGE_DIRECT: 'item_page_direct',
  LANDING_TOP_BANNER: 'landing_top_banner',
  LANDING_LEARN_MORE: 'landing_learn_more',
  LANDING_HOMEPAGE_PROMO: 'landing_homepage_promo',
  LANDING_SETTINGS_PROMO: 'landing_settings_promo',
}

export const BANNER_ENTRY_POINTS = [
  SubscriptionEntryPoints.LANDING_HOMEPAGE_PROMO,
  SubscriptionEntryPoints.LANDING_SETTINGS_PROMO,
]

export default SubscriptionEntryPoints
